import axios from 'axios'
import { Message } from 'element-ui'
// import { getUid, setUid, removeUid,getToken, setToken, removeToken } from '@/store/session'
import { getUid, setUid, removeUid,getToken, setToken, removeToken } from '@/store/cookies'
// 创建axios实例
const service = axios.create({
  timeout: 30000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  console.log('接口地址：', config.baseURL + config.url, '; 参数：', JSON.stringify(config.data))
    config.headers['Content-Type'] = 'application/json'
    config.headers['token'] = getToken()
  return config
}, error => {
  Promise.reject(new Error(error))
})

// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
      console.log(response.headers.userid)
      console.log(res)
      if(response.headers.token){
          setToken(response.headers.token)
          setUid(response.headers.userid)
      }
    if (res.code === 200) {
      return res.data
    } else {
      Message({
        message: res.message,
        type: 'error',
        duration: 5 * 1000
      })
        if(res.code === 500){
            console.log(11111)
            // this.$router.push()
        }
      return Promise.reject(new Error('error'))
    }
  },
  error => {
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(new Error(error))
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/request.js